module.exports = __webpack_public_path__ + "img/mobile_crane_h2.97516d23.png";